import React, { useState, useEffect } from "react";
import { CloseModal } from "../../styles/globalSVG";
import { Grid, Button, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import useScreenSize from "components/customHooks/useScreenSize";
import UserRatingDisplay from "components/search/UserRatingDisplay";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import validator from "validator";
import { useMessageContextProvider } from "../context/MessageContext";
import { useRouter } from "next/router";
import api from "components/settings/api";
import { useAuth } from "components/context/auth";

const useStyle = makeStyles(() => ({
  boxContainer: {
    width: "179px",
    height: "140px",
    border: "1px solid #d8d8d8",
    textAlign: "center",
    padding: "20px 0 10px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
    borderTop: "4px solid #E67C89",
    borderRadius: "4px",
    margin: "0 1rem",
    "@media (max-width: 760px)": {
      margin: "2rem auto",
    },
  },

  titleStyle: {
    fontWeight: 700,
  },

  approveButton: {
    boxShadow: "1px 1px 1px 1px rgba(80, 80, 80, 0.13)",
    backgroundColor: "#2eb795",
    borderRadius: "8px",
    width: "163px",
    height: "37px",
    color: "#fff",
    fontSize: "16px",
    "@media (max-width: 760px)": {
      width: "109px",
      display: "inline-block",
    },
  },

  rejectButton: {
    backgroundColor: "#E67C89",
    borderRadius: "8px",
    width: "163px",
    height: "37px",
    color: "#fff",
    fontSize: "14px",
    "@media (max-width: 760px)": {
      width: "109px",
      display: "inline-block",
    },
  },
  modalWrapper: {
    position: "fixed",
    placeContent: "center",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    zIndex: "10002",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingRight: 17,
    "@media screen and (maxWidth: 700)": {
      placeContent: "flex-start",
    },
  },
  containerInner: {
    padding: "20px",
    width: "100%",
    "@media screen and (max-width: 500px)": {
      padding: "0 16px",
    },
    gap: "10px",
  },
  paper: {
    borderRadius: "5px",
    boxShadow: "2.5px 5px #464646",
    maxWidth: "500px",
  },
}));

const UserPreview = ({
  userInfo,
  skillStr,
  togglePreview,
  setModalStatus,
  applicant,
  teamData,
}) => {
  const [userRating, setUserRating] = useState();
  const institution = validator.unescape(userInfo.institution);
  const major = validator.unescape(userInfo.major);
  const location = validator.unescape(userInfo.location);
  const router = useRouter();
  const webpage = userInfo.webpage;
  const linkedin = userInfo.linkedin;
  const bio = userInfo.bio;
  const profilePicture = userInfo.picture;
  const fullname = userInfo.fullname;
  const ratings = userInfo.Ratings;
  const messageContextProvider = useMessageContextProvider();

  const { user } = useAuth();

  // In some cases the db returns the userInfo in different objects.
  // For now this fixes the problem.
  if (userInfo.Skills === undefined) {
    skillSetStr = skillStr;
  }
  const goToUserProfile = () => {
    router.push(`/user/${userInfo?.public_user_id}`);
    window.scrollTo(0, 0);
  };
  const messageUser = () => {
    togglePreview();
    messageContextProvider.updateActiveUserToMessage(userInfo);
  };

  const close = () => {
    togglePreview();
  };

  const getApplicantRating = async () => {
    const res = await api.get(`/api/v1/ratings/rating/${userInfo.email}`);
    setUserRating(res.data);
  };

  const classes = useStyle();
  const screenLayoutType = useScreenSize();

  useEffect(() => {
    getApplicantRating();
  }, [teamData]);

  return (
    <div className={classes.modalWrapper}>
      <Paper className="container--modal-dark view-application">
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Button
            disableRipple={false}
            variant="text"
            className="button--modal_cancelJob"
            aria-label="Close modal"
            onClick={close}
          >
            <CloseRoundedIcon fontSize="inherit" color="inherit" />
          </Button>
        </Grid>
        <Grid item className="view-applicant_inner_modal">
          <div className="view-applicant_modal_container">
            <div
              className="member-avatar"
              style={{
                backgroundImage: `url(${userInfo.picture})`,
              }}
            />
            <div className="member-info">{userInfo.fullname}</div>
          </div>
          <hr />
          <>
            {(screenLayoutType === "smallScreen" ||
              screenLayoutType === "mediumScreen") && (
              <>
                <UserRatingDisplay ratingsArr={userRating} />
              </>
            )}
            <Grid item className={classes.titleStyle}>
              Skills:
            </Grid>
            <Grid item>
              {userInfo.Skills === undefined ? (
                <div>
                  {userInfo.Skills?.length > 0 ? (
                    <div>
                      {userInfo.Skills?.filter(
                        (skill) => skill && skill.skill !== "undefined"
                      ).map((skill, index) => (
                        <div key={index} className="user-skill_public">
                          {skill.skill}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div>None</div>
                  )}
                </div>
              ) : (
                userInfo.Skills?.filter(
                  (skill) => skill && skill.skill !== "undefined"
                ).map((skill, index) => (
                  <div key={index} className="user-skill_public">
                    {skill.skill}
                  </div>
                ))
              )}
            </Grid>
            {screenLayoutType === "largeScreen" && (
              <>
                <UserRatingDisplay ratingsArr={userRating} />
              </>
            )}
          </>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="stretch"
          className="button-preview"
        >
          <Grid item>
            <Button
              className={classes.approveButton}
              onClick={messageUser}
              disabled={user.id === userInfo.id}
              aria-label="Close modal"
            >
              Message Me
            </Button>
          </Grid>
          <Grid item>
            <Button className={classes.approveButton} onClick={goToUserProfile} aria-label="Close modal">
              View Profile
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};
export default UserPreview;
UserPreview.propTypes = {
  userInfo: PropTypes.object,
  skillStr: PropTypes.array,
};
